import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { SubscriptionPlanInterface } from '../../../interfaces/interfaces';

export const getAdSpaceSubscriptionPlansColumns = (
  setPlanToDelete: (plan: SubscriptionPlanInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setPlanToUpdate: (plan: SubscriptionPlanInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'planName', headerName: 'Plan Name', width: 140 },
  { field: 'description', headerName: 'Description', width: 250 },
  { field: 'price', headerName: 'Price', width: 100, type: 'number' },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setPlanToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setPlanToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];